import MarkdownPreview from "@uiw/react-markdown-preview";

interface TripSummaryCardProps {
  tripSummary: string;
  isDarkMode: boolean;
}

export function TripSummaryCard({ tripSummary, isDarkMode }: TripSummaryCardProps) {
  return (
    <div
      className={[
        "rounded-lg",
        "shadow-md",
        "border",
        "overflow-hidden",
        isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-200",
      ].join(" ")}
    >
      <div
        className={[
          "px-4",
          "py-3",
          "border-b",
          isDarkMode ? "bg-gray-800 border-gray-600" : "bg-white border-gray-200",
        ].join(" ")}
      >
        <h3 className={`text-lg! font-semibold ${isDarkMode ? "text-gray-100" : "text-gray-900"}`}>
          Trip Summary
        </h3>
      </div>
      <div className="p-4 [&_h1]:text-sm! [&_h2]:text-sm! [&_h3]:text-sm! [&_h4]:text-sm! [&_h5]:text-sm! [&_h6]:text-sm!">
        <MarkdownPreview
          source={tripSummary}
          wrapperElement={{
            "data-color-mode": isDarkMode ? "dark" : "light",
          }}
          className={isDarkMode ? "text-gray-200" : "text-gray-800"}
          style={
            isDarkMode ? { backgroundColor: "transparent" } : { backgroundColor: "transparent" }
          }
        />
      </div>
    </div>
  );
}
